import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { EspecialidadeMedicaService } from '@/core/api/sicom-api/servicos/pessoa-fisica/especialidade-medica/especialidade-medica.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { EspecialidadeMedicaRequest, EspecialidadeMedicaResponse } from '@/core/api/sicom-api/servicos/pessoa-fisica/especialidade-medica/especialidade-medica.model';

@Injectable({ providedIn: 'root' })
export class EspecialidadeMedicaServicosService {
    constructor(
        private api: EspecialidadeMedicaService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: EspecialidadeMedicaRequest, context?: HttpContext): Observable<EspecialidadeMedicaResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
